import { Group, Radio } from "@mantine/core";

import {
  VitalsUnitSystem,
  VitalsUnitSystems,
} from "@/encounters/components/VitalSigns/utils/vitals-unit-system";

type VitalsUnitsToggleProps = {
  value: VitalsUnitSystem;
  onChange: (unitSystem: VitalsUnitSystem) => void;
  /** Prefixes the radio test ids, e.g. `gynecological-vitals-units-metric`. */
  testIdPrefix?: string;
  "data-testid"?: string;
};

export function VitalsUnitsToggle({
  value,
  onChange,
  testIdPrefix = "vitals-units",
  "data-testid": dataTestId,
}: VitalsUnitsToggleProps) {
  return (
    <Radio.Group
      label="Units"
      value={value}
      data-testid={dataTestId ?? testIdPrefix}
      onChange={(unitSystem) => onChange(unitSystem as VitalsUnitSystem)}
    >
      <Group mt="md">
        <Radio
          label="Imperial"
          value={VitalsUnitSystems.Imperial}
          data-testid={`${testIdPrefix}-imperial`}
        />
        <Radio
          label="Metric"
          value={VitalsUnitSystems.Metric}
          data-testid={`${testIdPrefix}-metric`}
        />
      </Group>
    </Radio.Group>
  );
}

export default VitalsUnitsToggle;
